import auth from "@/auth.js";

export default {
  [auth.roles.USER]: [
    {
      title: "Довідники",
      action: "folder",
      subItems: [
        { text: "Виконавці", routeName: "employees" },
        { text: "Клієнти", routeName: "clients" },
        { text: "Менеджери", routeName: "managers" },
        { text: "Пакети Сплати", routeName: "paymentPackages" },
        { text: "Сервіси", routeName: "services" },
        { text: "Типи Сервісів", routeName: "serviceTypes" },
        { text: "Продукти", routeName: "products" },
        { text: "Проекти", routeName: "projects" },
        { text: "Джерела Коштів", routeName: "paymentSources" },
        { text: "Платники", routeName: "payers" },
        { text: "Категорії продуктів", routeName: "productCategories" },
        { text: "Департаменти", routeName: "departments" },
      ],
    },
    {
      title: "Операції",
      action: "business",
      subItems: [
        { text: "Оплати", routeName: "payments" },
        { text: "Бонуси", routeName: "bonuses" },
        { text: "Рахунки на сплату", routeName: "invoices" },
        { text: "Специфікації", routeName: "specifications" },
      ],
    },
    {
      title: "Звіти",
      action: "account_balance_wallet",
      subItems: [
        {
          text: "Загальний звіт по роботах",
          routeName: "worklogSummary",
        },
        { text: "Звіт по роботах", routeName: "worklog" },
        { text: "Баланс (за Пакетами)", routeName: "balance" },
        { text: "Заборгованість", routeName: "debt" },
        {
          text: "Сервіси до подовження",
          routeName: "servicesToProlongation",
        },
        {
          text: "Пакети до подовження v2",
          routeName: "packagesToProlongation",
        },
        {
          text: "Пакети до подовження",
          routeName: "packagesToProlongationOld",
        },
        {
          text: "Продажі (по оплатах)",
          routeName: "salesByPayments",
        },
        {
          text: "Бонуси менеджерів",
          routeName: "managersBonuses",
        },
      ],
    },
    {
      title: "Система",
      action: "settings",
      subItems: [
        { text: "Користувачі", routeName: "users" },
        { text: "Стан бази даних", routeName: "databaseState" },
      ],
    },
    {
      title: "Інтеграція",
      action: "sync",
      subItems: [
        { text: "Privat24", routeName: "privat24" },
        { text: "Taskombank", routeName: "taskombank" },
        { text: "Jira", routeName: "jira" },
      ],
    },
  ],
  [auth.roles.ADMINISTRATOR]: [
    {
      title: "Довідники",
      action: "folder",
      subItems: [
        { text: "Виконавці", routeName: "employees" },
        { text: "Клієнти", routeName: "clients" },
        { text: "Менеджери", routeName: "managers" },
        { text: "Пакети Сплати", routeName: "paymentPackages" },
        { text: "Сервіси", routeName: "services" },
        { text: "Типи Сервісів", routeName: "serviceTypes" },
        { text: "Продукти", routeName: "products" },
        { text: "Проекти", routeName: "projects" },
        { text: "Джерела Коштів", routeName: "paymentSources" },
        { text: "Платники", routeName: "payers" },
        { text: "Категорії продуктів", routeName: "productCategories" },
        { text: "Департаменти", routeName: "departments" },
      ],
    },
    {
      title: "Операції",
      action: "business",
      subItems: [
        { text: "Оплати", routeName: "payments" },
        { text: "Бонуси", routeName: "bonuses" },
        { text: "Рахунки на сплату", routeName: "invoices" },
        { text: "Специфікації", routeName: "specifications" },
      ],
    },
    {
      title: "Звіти",
      action: "account_balance_wallet",
      subItems: [
        {
          text: "Загальний звіт по роботах",
          routeName: "worklogSummary",
        },
        { text: "Звіт по роботах", routeName: "worklog" },
        { text: "Баланс (за Пакетами)", routeName: "balance" },
        { text: "Заборгованість", routeName: "debt" },
        {
          text: "Сервіси до подовження",
          routeName: "servicesToProlongation",
        },
        {
          text: "Пакети до подовження v2",
          routeName: "packagesToProlongation",
        },
        {
          text: "Пакети до подовження",
          routeName: "packagesToProlongationOld",
        },
        {
          text: "Продажі (по оплатах)",
          routeName: "salesByPayments",
        },
        {
          text: "Бонуси менеджерів",
          routeName: "managersBonuses",
        },
        {
          text: "Грейди співробітників",
          routeName: "employeesGrades",
        },
      ],
    },
    {
      title: "Система",
      action: "settings",
      subItems: [
        { text: "Користувачі", routeName: "users" },
        { text: "Налаштування", routeName: "settings" },
        { text: "Стан бази даних", routeName: "databaseState" },
      ],
    },
    {
      title: "Інтеграція",
      action: "sync",
      subItems: [
        { text: "Privat24", routeName: "privat24" },
        { text: "Taskombank", routeName: "taskombank" },
        { text: "Jira", routeName: "jira" },
      ],
    },
  ],
  [auth.roles.SALES_MANAGER]: [
    {
      title: "Довідники",
      action: "folder",
      subItems: [
        { text: "Виконавці", routeName: "employees" },
        { text: "Клієнти", routeName: "clients" },
        { text: "Менеджери", routeName: "managers" },
        { text: "Пакети Сплати", routeName: "paymentPackages" },
        { text: "Сервіси", routeName: "services" },
        { text: "Типи Сервісів", routeName: "serviceTypes" },
        { text: "Продукти", routeName: "products" },
        { text: "Проекти", routeName: "projects" },
        { text: "Джерела Коштів", routeName: "paymentSources" },
        { text: "Платники", routeName: "payers" },
        { text: "Категорії продуктів", routeName: "productCategories" },
        { text: "Департаменти", routeName: "departments" },
      ],
    },
    {
      title: "Операції",
      action: "business",
      subItems: [
        { text: "Оплати", routeName: "payments" },
        { text: "Бонуси", routeName: "bonuses" },
        { text: "Рахунки на сплату", routeName: "invoices" },
        { text: "Специфікації", routeName: "specifications" },
      ],
    },
    {
      title: "Звіти",
      action: "account_balance_wallet",
      subItems: [
        {
          text: "Загальний звіт по роботах",
          routeName: "worklogSummary",
        },
        { text: "Звіт по роботах", routeName: "worklog" },
        { text: "Баланс (за Пакетами)", routeName: "balance" },
        { text: "Заборгованість", routeName: "debt" },
        {
          text: "Сервіси до подовження",
          routeName: "servicesToProlongation",
        },
        {
          text: "Пакети до подовження v2",
          routeName: "packagesToProlongation",
        },
        {
          text: "Пакети до подовження",
          routeName: "packagesToProlongationOld",
        },
        {
          text: "Продажі (по оплатах)",
          routeName: "salesByPayments",
        },
        {
          text: "Бонуси менеджерів",
          routeName: "managersBonuses",
        },
      ],
    },
    {
      title: "Система",
      action: "settings",
      subItems: [
        { text: "Користувачі", routeName: "users" },
        { text: "Стан бази даних", routeName: "databaseState" },
      ],
    },
    {
      title: "Інтеграція",
      action: "sync",
      subItems: [
        { text: "Privat24", routeName: "privat24" },
        { text: "Taskombank", routeName: "taskombank" },
        { text: "Jira", routeName: "jira" },
      ],
    },
  ],
  [auth.roles.ACCOUNT_MANAGER]: [
    {
      title: "Довідники",
      action: "folder",
      subItems: [
        { text: "Виконавці", routeName: "employees" },
        { text: "Клієнти", routeName: "clients" },
        { text: "Менеджери", routeName: "managers" },
        { text: "Пакети Сплати", routeName: "paymentPackages" },
        { text: "Сервіси", routeName: "services" },
        { text: "Типи Сервісів", routeName: "serviceTypes" },
        { text: "Продукти", routeName: "products" },
        { text: "Проекти", routeName: "projects" },
        { text: "Джерела Коштів", routeName: "paymentSources" },
        { text: "Платники", routeName: "payers" },
        { text: "Категорії продуктів", routeName: "productCategories" },
        { text: "Департаменти", routeName: "departments" },
      ],
    },
    {
      title: "Операції",
      action: "business",
      subItems: [
        { text: "Оплати", routeName: "payments" },
        { text: "Бонуси", routeName: "bonuses" },
        { text: "Рахунки на сплату", routeName: "invoices" },
        { text: "Специфікації", routeName: "specifications" },
      ],
    },
    {
      title: "Звіти",
      action: "account_balance_wallet",
      subItems: [
        {
          text: "Загальний звіт по роботах",
          routeName: "worklogSummary",
        },
        { text: "Звіт по роботах", routeName: "worklog" },
        { text: "Баланс (за Пакетами)", routeName: "balance" },
        { text: "Заборгованість", routeName: "debt" },
        {
          text: "Сервіси до подовження",
          routeName: "servicesToProlongation",
        },
        {
          text: "Пакети до подовження v2",
          routeName: "packagesToProlongation",
        },
        {
          text: "Пакети до подовження",
          routeName: "packagesToProlongationOld",
        },
        {
          text: "Продажі (по оплатах)",
          routeName: "salesByPayments",
        },
        {
          text: "Бонуси менеджерів",
          routeName: "managersBonuses",
        },
      ],
    },
    {
      title: "Система",
      action: "settings",
      subItems: [
        { text: "Користувачі", routeName: "users" },
        { text: "Стан бази даних", routeName: "databaseState" },
      ],
    },
    {
      title: "Інтеграція",
      action: "sync",
      subItems: [
        { text: "Privat24", routeName: "privat24" },
        { text: "Taskombank", routeName: "taskombank" },
        { text: "Jira", routeName: "jira" },
      ],
    },
  ],
  [auth.roles.ACCOUNT_CLIENT]: [
    {
      title: "Головна",
      action: "home",
      routeName: "main",
    },
    {
      title: "Звіт по роботах",
      routeName: "worklog",
    },
    {
      title: "Баланс (за Пакетами)",
      routeName: "balance",
    },
    {
      title: "Специфікації",
      routeName: "clientSpecifications",
    },
  ],
};
